import { render, staticRenderFns } from "./OrderRequestsList.vue?vue&type=template&id=7068a723&"
import script from "./OrderRequestsList.vue?vue&type=script&lang=js&"
export * from "./OrderRequestsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports